export default __webpack_public_path__ + "178cbc93e74148f92ffab797ef22f716.svg";